import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axios';
import { ApiResponseData } from '../../types/apiResponse.types';

export const getStripeCustomerId = createAsyncThunk(
  'orgsNew/getStripeCustomerId',
  async (orgId: string, { fulfillWithValue, rejectWithValue, signal }) => {
    try {
      const response = await axios.get<
        ApiResponseData<{
          orgId: string;
          stripeCustomerId: string | null;
        }>
      >(`/su/orgs/${orgId}/stripeCustomerId`, { signal });

      return fulfillWithValue(response.data.payload.stripeCustomerId);
    } catch (e) {
      return rejectWithValue(null);
    }
  }
);

export const updateStripeCustomerId = createAsyncThunk<
  string | null,
  { orgId: string; stripeCustomerId: string | null }
>(
  'orgsNew/updateStripeCustomerId',
  async (
    { orgId, stripeCustomerId },
    { fulfillWithValue, rejectWithValue, signal }
  ) => {
    try {
      const response = await axios.patch<
        ApiResponseData<{ orgId: string; stripeCustomerId: string | null }>
      >(`/su/orgs/${orgId}/stripeCustomerId`, { stripeCustomerId }, { signal });

      return fulfillWithValue(response.data.payload.stripeCustomerId);
    } catch (e) {
      return rejectWithValue(null);
    }
  }
);
